export type StatusChipColor = "success" | "warning" | "default";
export type StatusBadgeVariant =
  | "default"
  | "destructive"
  | "secondary"
  | "success"
  | "warning";
export type StatusColor = StatusChipColor | "error" | "info" | "primary";

// Shared chip-color mapping for Property/Site lifecycle statuses. Active is always "success"
// and Archived is always "default" -- every other status (Staging, Degraded, unset) reads as
// a "warning" chip. Used by AdminSites, Properties, PropertySiteCards, and AdminSite.
export function statusChipColor(status?: string | null): StatusChipColor {
  if (status === "Active") return "success";
  if (status === "Archived") return "default";
  return "warning";
}

export function statusBadgeVariant(
  status?: string | null,
): StatusBadgeVariant {
  return statusBadgeVariantFromColor(statusChipColor(status));
}

export function statusBadgeVariantFromColor(
  color: StatusColor,
): StatusBadgeVariant {
  switch (color) {
    case "error":
      return "destructive";
    case "default":
      return "secondary";
    case "primary":
    case "info":
      return "default";
    default:
      return color;
  }
}

export function statusBadgeOutlineClass(color: StatusColor): string {
  switch (color) {
    case "success":
      return "border-emerald-300 bg-transparent text-emerald-900 dark:border-emerald-800 dark:text-emerald-100";
    case "warning":
      return "border-amber-300 bg-transparent text-amber-900 dark:border-amber-800 dark:text-amber-100";
    case "error":
      return "border-destructive bg-transparent text-destructive";
    case "info":
      return "border-blue-300 bg-transparent text-blue-900 dark:border-blue-800 dark:text-blue-100";
    case "primary":
      return "border-primary bg-transparent text-primary";
    default:
      return "";
  }
}
